import { Flex, Grid, GridItem, Text } from '@cad-arc';
import { UnitQueueWireDto } from '@mark43/cad-api';
import { FrUnitStatus } from '../fr-unit-status';
import { FrAssistingUnitChip } from '../fr-assisting-unit-chip';
import { Tooltip } from '../../common/components/tooltip';
import { colors } from '../../colors/colors';

const PLACEHOLDER = '—';

export function FrUnitsListDrawerItem({
    unit,
    handleViewUnitOnMap,
    goToEventNarrativeTab,
}: {
    unit: UnitQueueWireDto;
    handleViewUnitOnMap: () => void;
    goToEventNarrativeTab?: () => void;
}) {
    const unitHeaderBackgroundColor = unit.hasInProgressEmergency
        ? colors.unitEmergency
        : 'surface.foreground';

    return (
        <Flex py={1} key={unit.id}>
            <Flex
                data-testid={`fr-units-list-item-${unit.id}`}
                minH="90px"
                w="100%"
                flexDirection="column"
                borderRadius="md"
                border="sm"
                borderColor="border.default"
                bgColor="surface.canvas"
                p={2}
                gap={2}
                boxSizing="border-box"
            >
                <Grid
                    bgColor={unitHeaderBackgroundColor}
                    borderRadius="base"
                    templateColumns="1fr 3fr"
                    gridGap="22px"
                    px="8px"
                    boxSizing="border-box"
                    justifyContent="center"
                    cursor={unit?.eventQueueView?.id ? 'pointer' : 'default'}
                    onClick={handleViewUnitOnMap}
                    _hover={{
                        backgroundColor: 'var(--arc-colors-surface-accent)'
                    }}
                >
                    <GridItem minW={unit.personnelFullName ? '100px' : undefined}>
                        <Flex justifyContent="center" alignItems="center" gap="8px">
                            <Tooltip overlay={unit.callSign}>
                                <Text
                                    fontSize="lg"
                                    fontWeight="bold"
                                    style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        textWrap: 'nowrap',
                                    }}
                                >
                                    {unit.callSign}
                                </Text>
                            </Tooltip>
                            {unit?.unitBeat && (
                                <Tooltip overlay={unit.unitBeat}>
                                    <Text
                                        fontSize="md"
                                        lineHeight="27px"
                                        style={{
                                            minWidth: '28px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            textWrap: 'nowrap',
                                        }}
                                    >
                                        {unit.unitBeat}
                                    </Text>
                                </Tooltip>
                            )}
                        </Flex>
                    </GridItem>
                    <GridItem justifyContent="center" alignItems="center" overflow="hidden">
                        <Tooltip overlay={unit.personnelFullName?.toUpperCase() ?? '--'}>
                            <Text noOfLines={1} fontSize="md" lineHeight="27px">
                                {unit.personnelAbbreviatedName?.toUpperCase() ?? '--'}
                            </Text>
                        </Tooltip>
                    </GridItem>
                </Grid>
                <Grid templateColumns="1fr 3fr" justifyContent="center">
                    <GridItem
                        flexDirection="column"
                        pr={4}
                        alignItems="center"
                        display="flex"
                        minW="115px"
                        boxSizing="border-box"
                    >
                        <FrUnitStatus unit={unit} vertical />
                    </GridItem>
                    <GridItem
                        flexDirection="column"
                        pl={4}
                        cursor="pointer"
                        onClick={goToEventNarrativeTab}
                        borderRadius="md"
                        _hover={{ backgroundColor: 'var(--arc-colors-interactive-hover)' }}
                    >
                        <Tooltip overlay={unit.unitLocation}>
                            <Text noOfLines={1} fontSize="md" fontWeight="bold">
                                {unit.unitLocation ?? PLACEHOLDER}
                            </Text>
                        </Tooltip>
                        <Tooltip overlay={unit.eventQueueView?.cfsNumberAndText}>
                            <Text noOfLines={1} fontSize="md">
                                {unit.eventQueueView?.cfsNumberAndText ?? PLACEHOLDER}
                            </Text>
                        </Tooltip>
                        <Tooltip overlay={unit.skills}>
                            <Text noOfLines={1} fontSize="md" isItalic>
                                {unit.skills ?? PLACEHOLDER}
                            </Text>
                        </Tooltip>
                    </GridItem>
                </Grid>
                <Flex justifyContent="end" alignItems="center">
                    <FrAssistingUnitChip unit={unit} />
                </Flex>
            </Flex>
        </Flex>
    );
}
